import * as React from 'react'
import * as _ from 'lodash'
import { useDispatch } from 'react-redux'
import { Button, Form, Spinner, Container } from 'react-bootstrap'
import IosCallOutline from 'react-ionicons/lib/IosCallOutline'
import IosCashOutline from 'react-ionicons/lib/IosCashOutline'
import IosDesktopOutline from 'react-ionicons/lib/IosDesktopOutline'
import IosMailOutline from 'react-ionicons/lib/IosMailOutline'
import IosTextOutline from 'react-ionicons/lib/IosTextOutline'
import IosNavigateOutline from 'react-ionicons/lib/IosNavigateOutline'
import IosSendOutline from 'react-ionicons/lib/IosSendOutline'
import { AxiosInstance } from '../../../../utils/RequestMethods'
import { makeCallStart } from '../../../../redux/actions/twilioActions'
import config from '../../../../constants/config'


import { contactDate, yourContact, myContact, myContactParent, styles } from './style'
import ContactFormSubmission from './ContactFormSubmission'
import ContactTranscription from './ContactTranscription'
import { ClientT } from '../../../../types/Users'
import ContactPerson from './ContactPerson'

import ContactPhone from './ContactPhone'
import { getBaseUrl, stringLitArray } from '../../../../utils/utilsT'
import ContactTabSample from './ContactTabSample'
import { css } from 'glamor'
import { useImmer } from 'use-immer'
import ButtonLoading from '../../../../components/ButtonLoading/ButtonLoading'
import ContactSms from './ContactSms'
import { ContactPersonT, JobT } from '../../../../types/Job'
import instanceSocketClient, { getInstanceSocketClient } from '../../../../service/InstanceSocketClient'
import { JobMode } from '../Job'
import { socketEvents } from '../../../../service/socketEvents'
import FormSendBookingInfo from './FormSendBookingInfo'
import { useRouteMatch } from 'react-router'
import { PhoneAnnotationT } from './AnnotationPhone'
import { AnnotationLineItemT } from '../../../../types/AnnotationLineItemT'
import { SmsAnnotationT } from '../../../../types/SmsAnnotationT'

interface ContactTabProps {
  job: JobT
  jobMode: JobMode
  tabIsActive: boolean
  socket?: any
}

type ContactModeT = "call" | "email" | "text" | "sendBookingInfo"

const ContactTypeT = stringLitArray(["smuvsrp_quote", "smuvsrp_chat", "phone", "sms", 'email']);
export type ContactTypeTStrings = (typeof ContactTypeT)[number];


const DirectionT = stringLitArray(["", "incoming", "outgoing"]);
export type DirectionTStrings = (typeof DirectionT)[number];

export interface ContactHistoryT {
  id: number
  date: string
  jobId: number
  type: ContactTypeTStrings | null
  senderId: number
  sender: ClientT
  chat: any
  meta: any
  direction: DirectionTStrings | null
  disputeNotes?: Array<PhoneAnnotationT | SmsAnnotationT>
}

export const durationToDDHHMMSSMS = (closedIn) => {
  var sec_num = parseInt(closedIn, 10); // don't forget the second param
  var days = Math.floor(sec_num / 86400);
  var hours = parseInt(('0' + Math.floor(closedIn / 3600) % 24).slice(-2));
  var minutes = parseInt(('0' + Math.floor(closedIn / 60) % 60).slice(-2));
  var seconds = parseInt(('0' + closedIn % 60).slice(-2));

  if (hours < 10) { hours = 0 + hours; }
  if (minutes < 10) { minutes = 0 + minutes; }
  if (seconds < 10) { seconds = 0 + seconds; }
  let daysText = days > 0 ? `${days} days ` : " ";
  let hoursText = hours > 0 ? `${hours} hours ` : " ";
  let minutesText = minutes > 0 ? `${minutes} minutes ` : "";
  return `${daysText}${hoursText}${minutesText}${seconds} seconds`;
}


const ContactTab: React.FunctionComponent<ContactTabProps> = (props): JSX.Element => {
  const [contactMode, setContactMode] = React.useState<ContactModeT>('call')      // Modes: call | email | text  NOTE: There is also a `site` mode from plugin
  const [communicationsItems, setCommunicationsItems] = React.useState([])
  const [contacts, setContacts] = React.useState([])
  const [selectedContact, setSelectedContact] = React.useState(null);
  const [isReady, setIsReady] = React.useState(false);
  const [page, setPage] = React.useState(1)
  const [smsBody, setSmsBody] = React.useState('')
  const [socketIsReady, setSocketIsReady] = React.useState(false)
  const [loading, setLoading] = React.useState(false);
  const [urlDispute, setUrlDispute] = React.useState(null);
  let match = useRouteMatch();
  const [paginationInfo, setPaginationInfo] = useImmer({
    total: 0,
    totalPages: 0,
  });
  const dispatch = useDispatch();

  const jobIdRef = React.useRef(null);


  React.useEffect(() => {

    getCommunications()
  }, []);

  React.useEffect(() => {

    if (!socketIsReady && props.jobMode == "edit" && props.socket) {
      setSocketIsReady(true)
      listenSocket(props.socket, props.job.id)
    }

  }, [props.job, props.socket]);


  const listenSocket = (socket, jobId) => {

    jobIdRef.current = jobId
    const event = `${socketEvents.updateCommunications}-${jobId}`
    // socket.onAny((eventName, ...args) => {
    //   console.log("[update-communications]  ", eventName)
    //   console.log("[update-communications]", args)
    // });
    // socket.on("disconnect", (data) => {
    //   console.log("[update-communications]", data)
    //   console.log("[update-communications]", data)
    // });
    socket.on(event, (data) => {
      setLoading(true)
      console.log("update-communications   ", data)
      getCommunications(page, true)
      socket.emit("feedback-update-communications", { path: "job", tab: "contact", jobId: jobId, platform: config.platform })
    })
  }


  const getCommunications = async (page = 1, rest = false) => {
    try {
      let params = {
        order: "desc",
        page: page,
        per_page: 5,
      }
      let options = {
        data: params
      }

      let res = await AxiosInstance.get(`${config.url.jobs}/${props.job.id}/communications`, options)
      setIsReady(true)
      setLoading(false)
      if (res && res.data && res.headers['x-wp-totalpages']) {
        if (rest) {
          setCommunicationsItems(res.data)
        } else {
          // @ts-ignore
          setCommunicationsItems([...communicationsItems, ...res.data])
        }

        const total = res.headers['x-wp-total']
        const totalPages = res.headers['x-wp-totalpages']

        setPaginationInfo((draft => {
          draft.total = total
          draft.totalPages = totalPages
        }))
      }

    } catch (error) {
      setLoading(false)
      setIsReady(true)
    }
  }
  /**
   * use action redux
   */
  const makeCall = (contactPerson: ContactPersonT) => {
    // dispatch(makeCallStart({
    //     To: "james",
    //     jobId:  props.job.id
    // }))
    // return;
    if (contactPerson != null) {

      dispatch(makeCallStart({
        To: contactPerson.phone,
        jobId: props.job.id
      }))
    }

  }

  const sendMessage = async (): Promise<string> => {
    if (selectedContact == null) {
      throw new Error("Please select contact .")
    }
    if (smsBody == "") {
      throw new Error(" Invalid sms text.")
    }
    let params = {
      to: selectedContact.phone,
      message: smsBody,
      jobId: props.job.id
    }
    try {
      let res = await AxiosInstance.post(`${config.url.twilio}/message`, params)
      if (res && res.data) {
        setSmsBody("")
        setTimeout(() => {
          getCommunications(page, true)
        }, 100);
        return "Message sent."
      }

    } catch (error) {
      throw error
    }

  }

  /**
   *
   * @param communications
   */
  const isAllCommunications = (communications: Array<ContactHistoryT>, total: number) => {
    return communications.length == total
  }

  /**
   *
   * @param communications
   * @param index
   */
  const isFirstCommunication = (communications: Array<ContactHistoryT>, total: number, index: number): boolean => {
    if (isAllCommunications(communications, total) && Number(communications.length) == Number(index)) {
      return true;
    }
    return false;
  }



  const renderContactHistory = () => {
    if (_.isArray(communicationsItems)) {
      return [...communicationsItems].reverse().map((item: ContactHistoryT, index) => {
        // console.log("isFirstCommunication", isFirstCommunication(communicationsItems, paginationInfo.total, index))

        switch (item.type) {
          case "smuvsrp_quote":
            return <ContactFormSubmission key={index} job={props.job} item={item} />
          case "smuvsrp_chat":
            return <ContactTranscription key={index} job={props.job} item={item} />
          case "phone":
            return <ContactPhone key={index} job={props.job} item={item} />
          case "sms":
            return <ContactSms key={index} job={props.job} item={item} />
          default:
            return null;
        }

      })
    }
  }

  const renderComposerSection = () => (
    <>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
        gap: 8,
        width: '100%',
        marginBottom: 5,
      }}>
        {[
          { key: 'call', label: 'Call', icon: IosCallOutline },
          { key: 'text', label: 'Text', icon: IosTextOutline },
          { key: 'email', label: 'Email', icon: IosMailOutline },
          { key: 'sendBookingInfo', label: 'Booking Info', icon: IosSendOutline },
        ].map((mode) => {
          const isActive = contactMode === mode.key
          const IconCmp = mode.icon
          return (
            <Button
              key={mode.key}
              variant={isActive ? 'primary' : 'light'}
              onClick={() => setContactMode(mode.key as ContactModeT)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 8,
                minHeight: 44,
                fontWeight: 600,
                borderRadius: 10,
                border: isActive ? '1px solid #0d6efd' : '1px solid #dfe3e8',
                color: isActive ? '#fff' : '#334155',
                background: isActive ? '#0d6efd' : '#fff',
                width: '100%',
              }}>
              <IconCmp color={isActive ? 'white' : '#475569'} />
              <span>{mode.label}</span>
            </Button>
          )
        })}
      </div>

      <ContactPerson job={props.job} contactMode={contactMode} selectedContact={selectedContact}
        onChangeContact={(contact: ContactPersonT) => {
          setSelectedContact(contact)
        }}
      />

      {contactMode == 'call' && <div>
        <Button
          variant='success'
          onClick={(): void => makeCall(selectedContact)}
          style={{ minWidth: 140, width: '100%', maxWidth: 240, borderRadius: 10, fontWeight: 600 }}>
          <strong><IosCallOutline color='white' />&nbsp;Call</strong>
        </Button>
      </div>}
      {contactMode == 'text' && <div>
        <h3>Send Text</h3>
        <Form>
          <Form.Group>
            <Form.Control
              value={`${smsBody}`}
              as="textarea"
              className="input-material"
              rows={3}
              onChange={(event: any) => {
                setSmsBody(event.target.value)
              }}
            />
          </Form.Group>
          <ButtonLoading
            variant='success'
            style={{ minWidth: 140, width: '100%', maxWidth: 240, borderRadius: 10, fontWeight: 600 }}
            onClickFetching={sendMessage}>
            <strong><IosTextOutline color='white' />&nbsp;Send</strong>
          </ButtonLoading>
          {/* <Button variant='success'><strong><IosTextOutline color='white' />&nbsp;Send</strong></Button> */}
        </Form>
      </div>}
      {contactMode == 'email' && <div>
        <h3>Send Email</h3>
        <Form>
          <Form.Group>
            <Form.Label>Title</Form.Label>
            <Form.Control
              className="input-material" />
          </Form.Group>
          <Form.Group>
            <Form.Label>Body</Form.Label>
            <Form.Control
              as="textarea"
              className="input-material"
              rows={3} />
          </Form.Group>
          <Button variant='success' style={{ minWidth: 140, width: '100%', maxWidth: 240, borderRadius: 10, fontWeight: 600 }}>
            <strong><IosMailOutline color='white' />&nbsp;Send</strong>
          </Button>
        </Form>
      </div>}
      {contactMode == 'sendBookingInfo' && <FormSendBookingInfo
        selectedContact={selectedContact}
        job={props?.job}
        referesh={() => {
          getCommunications(page, true)
        }}
      />}
    </>
  )

  if (!isReady) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" variant="info" />
      </Container>
    )
  }
  return (
    <div style={{ overflow: "hidden", display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, position: 'relative' }} className="" >
      {/* <ContactTabSample /> */}
      <div style={{
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        position: 'relative',
        padding: '8px 0 12px 0',
      }}>
        {(paginationInfo.total != 0 && paginationInfo.total > communicationsItems.length) &&
          <div style={{
            position: 'sticky',
            top: 0,
            zIndex: 6,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            padding: '0 0 10px 0',
            borderBottom: '1px solid #f1f3f5',
            background: '#fff',
            clear: 'both',
          }}>
            <ButtonLoading variant='outline-secondary'
              style={{ borderRadius: 999, minWidth: 180, fontWeight: 600 }}
              noShowResultMessageSuccess
              noShowResultMessageError
              timeShowMsg={100}
              onClickFetching={async (event): Promise<string> => {
                let countPage = page + 1
                setPage(countPage)
                try {
                  let res = await getCommunications(countPage)
                  return ""
                } catch (error) {
                  throw new Error(`${error}`)
                }

              }}>Load more</ButtonLoading>
          </div>}
        {renderContactHistory()}
      </div>

      {loading && <div style={{
        position: 'absolute',
        inset: 0,
        zIndex: 20,
        background: 'rgba(255, 255, 255, 0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
      }}>
        <div className="d-flex flex-column align-items-center justify-content-center">
          <span>Loading...</span>
          <Spinner animation="border" variant="secondary" />
        </div>
      </div>}

      <div style={{
        flexShrink: 0,
        zIndex: 5,
        background: '#fff',
        borderTop: '1px solid #e9ecef',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.04)',
        paddingTop: 2,
        paddingBottom: 0,
        marginBottom: 0,
      }}>
        {renderComposerSection()}
      </div>

    </div>
  )
}

export default React.memo(ContactTab)
